import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyBeirutSection from './components/WhyBeirutSection';
import WhoSection from './components/WhoSection';
import ExperienceSection from './components/ExperienceSection';
import NumbersSection from './components/NumbersSection';
import InvitationSection from './components/InvitationSection';
import PartnershipCTA from './components/PartnershipCTA';
import { SEO } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": "Women In Wealth Summit",
    "description": "A private summit bringing together women who move capital, shape legacies, and redefine the future of global wealth.",
    "startDate": "2026-03",
    "endDate": "2026-03",
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "location": {
      "@type": "Place",
      "name": "Beirut, Lebanon",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Beirut",
        "addressCountry": "LB"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "33.8886",
        "longitude": "35.4955"
      }
    },
    "organizer": {
      "@type": "Person",
      "name": "Racha Mezher",
      "jobTitle": "Founder & CEO",
      "worksFor": {
        "@type": "Organization",
        "name": "Wealthrise Management"
      }
    },
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InvitationOnly",
      "url": `${siteUrl}/attend`
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Women In Wealth Summit · Beirut Lebanon · March 2026 | Private Summit for Women Leaders"
        description="Join the exclusive Women In Wealth Summit in Beirut, Lebanon, March 2026. A private gathering for women who move capital, shape legacies, and redefine global wealth. Hosted by Racha Mezher, founder of Wealthrise Management. By invitation only."
        keywords="women in wealth, women in wealth summit, family office women, private equity women, venture capital women, wealth management women, Beirut summit, Lebanon business summit, Racha Mezher, Wealthrise Management, women investors, women capital allocators, family office summit"
        canonical={`${siteUrl}/`}
        schema={schema}
      />
      <Navigation />
      <HeroSection />
      <NumbersSection />
      <WhoSection />
      <ExperienceSection />
      <WhyBeirutSection />
      <PartnershipCTA />
      <InvitationSection />
      <Footer />
    </div>
  );
}
